/**
 * Navigation guard to detect back navigation to choose items from item processing.
 * When detected, resets the return session to allow re-selection of items.
 *
 * This guard is registered once at the route level to avoid the multiplication
 * issue where each composable instance would register its own copy.
 *
 * @see ROUTING_COMPOSABLE_REFACTOR.md - P3: Navigation Guard Registered Per Instance
 */
export function setupReturnNavigationGuard(router) {
  router.beforeEach((to, from) => {
    // Check if navigating TO choose items page FROM an item processing page
    const goingToChooseItems = to.path.includes('/items') && to.name === 'AppReturnChooseItems'
    const comingFromItemProcessing = from.path.includes('/item/')

    if (goingToChooseItems && comingFromItemProcessing) {
      const customerReturnStore = useCustomerReturnStore()
      customerReturnStore.resetForItemReselection()
    }
  })
}
